/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import EntityEnum from 'astro/enum/entity';

import * as Energy from 'astro/value/energy';


export default class
{
  constructor (variant, source)
  {
    this.unit = { type: EntityEnum.Unit, variant, source, zone: source.toString(), args: { target: null, shape: null, health: Energy.fromPercentage(35) }, status: null };
  }


  setStatus (type, date = null)
  {
    this.unit.status = { type, event: date ? { id: null, date } : null };
  }


  setGalaxy (galaxy)
  {
    this.unit.galaxy = galaxy;
  }


  setPlanet (planet)
  {
    this.unit.planet = planet;
  }


  setUpdateDate (date)
  {
    this.unit.update_date = date;

    if (this.unit.status)
    {
      this.unit.status.date = date;
    }
  }


  getType ()
  {
    return this.unit;
  }


  getID ()
  {
    return this.unit.zone;
  }


}
